import { render, staticRenderFns } from "./mini-table.vue?vue&type=template&id=62ad7cdc&scoped=true&lang=pug&"
var script = {}
import style0 from "./mini-table.vue?vue&type=style&index=0&id=62ad7cdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ad7cdc",
  null
  
)

export default component.exports